import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@fontsource-variable/inter/wght.css'
import '@fontsource-variable/fraunces/wght.css'
import './styles/theme.css'
import { App } from './App.tsx'

/*
 * Les polices sont importées ici plutôt que liées dans index.html : Vite les
 * empreinte alors d'un hash et les sert depuis notre domaine. Aucun CDN en
 * production — ce serait une dépendance réseau de plus pour une app qui doit
 * fonctionner hors-ligne.
 *
 * On importe `wght.css` et non `index.css` : seul l'axe de graisse nous
 * sert, l'axe italique doublerait les fichiers pour un style que Popote
 * n'utilise nulle part.
 *
 * Les sous-ensembles cyrillique, grec et vietnamien sont présents dans le
 * build mais ne sont JAMAIS téléchargés : les @font-face portent un
 * `unicode-range`, et le navigateur ne va chercher que le latin. Le vrai
 * coût serait dans le précache du service worker — c'est donc là qu'on
 * filtre, en n'y mettant que les fichiers latins (voir public/sw.js).
 */

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
